import {
  Flex,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";
import { FiAlertTriangle } from "react-icons/fi";
import { CardLoginHasAccount } from "../Cards/CardLoginHasAccount";

export function ModalLogin({ open, close, doc, isPF, email, existEmail, existDoc, Msg }) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });
  return (
    <Modal isOpen={open} onClose={close} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={"10px"}>
        <ModalBody>
          <Flex my="1rem" direction="column">
            <Text
              textAlign={"center"}
              fontSize={"h4"}
              color={"ll-gray.300"}
              fontWeight={"500"}
              cursor={"default"}
            >
              Já temos uma conta vinculada ao {isPF ? "CPF" : "CNPJ"}:
            </Text>

            <Flex textAlign={"center"} w={"full"} justifyContent={"center"}>
              {existEmail && (
                <Text fontSize={"h3"} color={"ll-green.main"} fontWeight={"500"}>
                  {email}
                </Text>
              )}
              {existDoc && (
                <Text fontSize={"h3"} color={"ll-green.main"} fontWeight={"500"}>
                  {doc}
                </Text>
              )}
            </Flex>

            {existEmail && (
              <Flex textAlign={"center"} mb={"15px"}>
                <Text mr={"5px"}>{isPF ? "CPF" : "CNPJ"} da conta:</Text>
                <Text>{Msg.split("cliente")?.[1]}</Text>
              </Flex>
            )}

            {existDoc && (
              <Flex justifyContent={"center"} mb={"15px"}>
                <Text
                  mr={"5px"}
                  textAlign={"center"}
                  fontSize={"h4"}
                  color={"ll-gray.300"}
                  fontWeight={"500"}
                  cursor={"default"}
                >
                  E-mail da conta:
                </Text>
                <Text
                  textAlign={"center"}
                  fontSize={"h4"}
                  color={"ll-gray.300"}
                  fontWeight={"500"}
                  cursor={"default"}
                >
                  {Msg.split("cliente:")?.[1]}
                </Text>
              </Flex>
            )}
            <Flex justifyContent={"center"}>
              <Flex
                mt={"15px"}
                mb={"15px"}
                cursor={"default"}
                borderRadius={"50px"}
                bgColor={"ll-red.200"}
                py={"15px"}
                px={"15px"}
                alignItems={"center"}
                justifyContent={"center"}
                w={"400px"}
              >
                <Flex w={"full"} alignItems={"center"} justifyContent={"center"}>
                  <IconButton
                    aria-label="Menu"
                    backgroundColor="transparent"
                    borderRadius="0"
                    fontSize="38px"
                    mr={"15px"}
                    icon={<FiAlertTriangle color="#FFFFFF" />}
                  />
                  <Text
                    textAlign={"start"}
                    fontSize={"text1"}
                    color={"ll-white.main"}
                    maxW={"300px"}
                  >
                    Seu cadastro da Pneufree.com é válido em nosso site. Por favor, use o mesmo
                    login e senha para finalizar seu pedido.
                  </Text>
                </Flex>
              </Flex>
            </Flex>

            <Text
              textAlign={"center"}
              color={"ll-blue.main"}
              fontSize={"titleProduct"}
              fontWeight={"500"}
              letterSpacing={"-1px"}
              mb={"15px"}
              cursor={"default"}
            >
              Faça seu login
            </Text>
            <CardLoginHasAccount checkout={true} />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
